import styled from 'styled-components';
import colors from '../../styles/colors';

export const Container = styled.div`
  width: 100%;
  background-color: ${colors.light1};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  min-height: fit-content;
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  padding: 10px 10px 0 10px;
  img {
    height: 40px;
    margin-bottom: 10px;
    margin-right: 10px;
  }
  h1 {
    color: ${colors.dark3};
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  @media (max-width: 600px) {
    justify-content: center;
  }
`;
